import { detect } from 'detect-browser';
import { SessionStore } from '../../constants/sessionStore';

export const iOS = (): boolean => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const macOS = (): boolean => {
  return ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(navigator.platform);
};

export const isBrowserSupported = (): boolean => {
  const support = sessionStorage.getItem(SessionStore.isBrowserSupported);

  if (support) return support === 'true';

  const browser = detect();
  let result = false;

  switch (browser && browser.name) {
    case 'chrome':
      result = !(
        navigator.userAgent.includes('Miui') ||
        navigator.userAgent.includes('Vivaldi') ||
        navigator.userAgent.includes('UCBrowser') ||
        navigator.userAgent.includes('UBrowser')
      );
      break;
    case 'firefox':
    case 'edge':
    case 'edge-ios':
    case 'edge-chromium':
    case 'safari':
    case 'ios':
    case 'crios':
      result = true;
      break;
  }

  // Storing in session because no need to calculate every time
  sessionStorage.setItem(SessionStore.isBrowserSupported, result.toString());

  return result;
};
export const getBrowserName = (): string => {
  const browser = detect();
  return browser && browser.name ? browser.name : '';
};
